// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2IhPK","errors":"Errors_errors__1atDa"};